import AssignPercentagesError from './AssignPercentagesError';
class MissingBeneficiaries extends AssignPercentagesError {
    constructor(options) {
        super("The request must include all of the investor's active beneficiaries", options);
    }
}
export default MissingBeneficiaries;
